import { Button, Chip, ChipStatus } from "@appcharge/shared-ui";
import { ColumnDef } from "@tanstack/react-table";
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { formatDateTimeByLocale } from "utils/formattingUtil";

import { TableCellEllipsis } from "components/Orders/Orders/Components/TableCellEllipsis";

import { EReportStatus, ReportTableRow } from "../types";

dayjs.extend(utc);

const reportStatusMapping: Record<EReportStatus, ChipStatus> = {
  [EReportStatus.CREATED]: 'success',
  [EReportStatus.IN_PROGRESS]: 'processing',
  [EReportStatus.FAILED]: 'danger'
};

const reportStatusLabels: Record<EReportStatus, string> = {
  [EReportStatus.CREATED]: 'Done',
  [EReportStatus.IN_PROGRESS]: 'Processing',
  [EReportStatus.FAILED]: 'Failed'
};

export const FINANCIAL_REPORTS_TABLE_COLUMNS = (
  onDownloadClick: (reportId: string) => void
): ColumnDef<ReportTableRow>[] => [
    {
      accessorKey: 'dateCreated',
      header: 'Date Created',
      cell: ({ getValue }) => <TableCellEllipsis>{formatDateTimeByLocale(getValue() as string)}</TableCellEllipsis>,
      enableSorting: true,
      sortDescFirst: true
    },
    {
      accessorKey: 'project',
      header: 'Project',
      cell: ({ getValue }) => <TableCellEllipsis>{getValue() as string}</TableCellEllipsis>,
      enableSorting: true
    },
    {
      accessorKey: 'startDate',
      header: 'Start',
      cell: ({ getValue }) => <TableCellEllipsis>{dayjs.utc(getValue() as string).format('MMM DD, YYYY')}</TableCellEllipsis>,
      enableSorting: true
    },
    {
      accessorKey: 'endDate',
      header: 'End',
      cell: ({ getValue }) => <TableCellEllipsis>{dayjs.utc(getValue() as string).format('MMM DD, YYYY')}</TableCellEllipsis>,
      enableSorting: true
    },
    {
      accessorKey: 'status',
      header: 'Status',
      cell: ({ getValue }) => {
        const status = getValue() as EReportStatus;
        return (
          <Chip variant="flat" status={reportStatusMapping[status]}>
            {reportStatusLabels[status]}
          </Chip>
        );
      },
      enableSorting: true
    },
    {
      accessorKey: 'reportId',
      header: 'Download Report',
      cell: ({ row }) => {
        const isDisabled = row.original.status !== EReportStatus.CREATED;
        return (
          <Button
            variant="outline"
            onClick={(e) => {
              e.stopPropagation();
              if (!isDisabled) {
                onDownloadClick(row.original.reportId);
              }
            }}
            disabled={isDisabled}
          >
            Download
          </Button>
        );
      }
    },
  ];

export const REPORT_TABLE_ROWS_PER_PAGE = 200;

